// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    activityDate: z.number(),
    userId: z.string().min(1).max(21),
    activityCount: z.number(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    activityDate: z.number(),
    userId: z.string().min(1).max(21),
    activityCount: z.number(),
});
export const AggregatedDailyActiveUsers = Object.freeze({
    table: 'aggregated_daily_active_users',
    tableSingular: 'aggregated_daily_active_user',
    fields: {
        tenantId: 'tenant_id',
        activityDate: 'activity_date',
        userId: 'user_id',
        activityCount: 'activity_count',
    },
    fieldKeys: [
        'tenantId',
        'activityDate',
        'userId',
        'activityCount',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
